<template>
  <div>
    <b-link
      class="font-weight-bold d-block text-nowrap mr-3 mb-2"
      @click="mudarComponente()"
    >
      <el-button
        id="voltar-lista-curso"
        style="border: none; background-color: transparent;"
        type="button"
        class="is-plain"
      >
        <i class="el-icon-back" />
        Cursos
      </el-button>
    </b-link>
    <div
      class="card p-2"
      style="height: 240px"
    >
      <div class="row align-items-center">
        <div class="col-6">
          <h2>
            Estatisticas
          </h2>
          <div class="mt-3">
            <label for="select-aluno">Filtra por Aluno</label>
            <b-form-select
              id="select-aluno"
              v-model="selected"
              :options="alunos"
              :value-field="valueField"
              :text-field="textField"
              @change="buscarEstatisticas(selected)"
            />
          </div>
        </div>
        <div class="col-6 d-flex justify-content-end align-items-center">
          <b-avatar
            :variant="`light-danger`"
            size="150"
          >
            <feather-icon
              size="21"
              icon="ActivityIcon"
            />
          </b-avatar>
        </div>
      </div>
    </div>

    <div>
      <b-row>
        <b-col
          lg="3"
          sm="6"
        >
          <statistic-card-horizontal
            style="height: 200px"
            icon="CpuIcon"
            :statistic="qtdAcesso"
            statistic-title="Quantidade de Acesso"
          />
        </b-col>
        <b-col
          lg="3"
          sm="6"
        >
          <statistic-card-horizontal
            style="height: 200px"
            icon="ServerIcon"
            color="success"
            :statistic="tempo_assistido"
            statistic-title="Tempo Assistido"
          />
        </b-col>
        <b-col
          lg="3"
          sm="6"
        >
          <statistic-card-horizontal
            style="height: 200px"
            icon="ActivityIcon"
            color="danger"
            :statistic="mediaProgresso + '%'"
            statistic-title="Progresso Medio"
          />
        </b-col>
        <b-col
          lg="3"
          sm="6"
        >
          <statistic-card-horizontal
            style="height: 200px"
            icon="AlertOctagonIcon"
            color="warning"
            :statistic="qtd_plays"
            statistic-title="Quantidade de Plays"
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import {
  BRow, BCol, BAvatar, BFormTextarea,
} from 'bootstrap-vue'

import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue'
import { useApi, useApiAWS } from '@/composables/useApi'

const apiBack = useApi()
const apiAws = useApiAWS()

export default {
  components: {
    BFormTextarea,
    BAvatar,
    BRow,
    BCol,
    StatisticCardHorizontal,
  },
  data() {
    return {
      alunos: [],
      // Area charts
      qtd_plays: '',
      tempo_assistido: '',
      mediaProgresso: '',
      qtdAcesso: '',
      subscribersGained: {},
      revenueGenerated: {},
      quarterlySales: {},
      ordersRecevied: {},
      cursoId: this.$route.params.id,
      valueField: 'id',
      textField: 'aluno_nome',
      selected: null,
      options: [
        { value: 0, text: 'Tudo' },
        { value: 704606, text: 'Aluno 1' },
        { value: 704653, text: 'Aluno 2' },
      ],
    }
  },
  created() {
    // Subscribers gained

  },
  mounted() {
    this.buscarEstatisticas(0)
    this.listarAlunos()
  },
  methods: {
    mudarComponente() {
      return this.$router.push('/cliTreinamentos')
    },
    async buscarEstatisticas(idAluno) {
      console.log(idAluno)
      await apiBack.post('/getEstatisticasCurso', {
        id_curso: this.cursoId,
        id_aluno: idAluno,
      })
        .then(data => {
          console.log(data.data)
          this.mediaProgresso = data.data.Media_Progresso !== null ? Math.floor(data.data.Media_Progresso) : 0;
          this.qtdAcesso = data.data.Soma_Qtd_Acesso !== null ? data.data.Soma_Qtd_Acesso : 0
          this.qtd_plays = data.data.Soma_qtd_plays !== null ? data.data.Soma_qtd_plays : 0
          this.tempo_assistido = data.data.Soma_tempo_assistido !== null ? data.data.Soma_tempo_assistido : 0
        })
        .catch(err => console.error(err))
    },
    async listarAlunos() {
      await apiBack.get(`/findAlunoByCurso?id=${this.cursoId}`)
        .then(data => {
          this.alunos = [{ id: 0, aluno_nome: 'Todos' }, ...data.data]
        })
        .catch(err => console.error(err))
    },
  },
}
</script>
